<template>
  <mock-up-main>
    <!-- صفحه خوش‌آمدگویی (Splash Screen) -->
    <component
      :is="components[value?.photo?.transition || 'scale']"
      mode="out-in"
      origin="center"
    >
      <div 
        v-if="showWelcome && value?.photo?.hasWelcome" 
        class="splash-screen d-flex flex-column justify-center align-center w-100 h-100 position-absolute"
        style="z-index: 100; background: #ffffff;"
        key="loading"
      >
        <div v-if="value?.photo?.welcome === ''" class="m-auto">
          <atom-spinner :animation-duration="1000" :size="80" color="#ff1d5e" />
        </div>
        <div v-else class="m-auto">
          <img 
            :src="value.photo.welcome" 
            alt="Welcome" 
            class="bg-white img-fluid rounded-circle mx-auto my-auto"
            width="100"
          />
        </div>
      </div>
    </component>

    <div 
      class="d-flex flex-column h-100 position-relative w-100 modern-bg" 
      style="overflow: hidden;"
      :style="{
        background: backgroundImage ? `url(${backgroundImage}) no-repeat center center / cover` : (value?.baseInfo?.sectionColor?.backGround || '#f4f6f9')
      }"
    >
      <div v-if="backgroundImage" class="bg-overlay"></div>

      <floating-btn
        v-if="value?.socialMedia && Object.keys(value.socialMedia).length > 0"
        v-model="value.socialMedia"
        :color="value?.baseInfo?.sectionColor?.icon || '#35F9F927'"
        class="position-absolute modern-float-btn"
        style="top: 20px; right: 20px; z-index: 20;"       
      />

      <!-- بدنه اصلی اسکرول شونده -->
      <div
        class="main-scroller overflow-y-auto hide-scrollbar w-100 h-100" 
        style="position: relative; z-index: 2;"
      >
        <drag-list v-model="draggingKeys">
          <template v-slot:default="{ item }">
            <div :key="item.name || item" class="drag-item-wrapper w-100">
              <template v-if="(item.name || item) === 'profile'">
                <div class=" profile-section mt-4 d-flex flex-column align-center text-center px-4">
                  
                  <div 
                    class="overlapping-avatar elevation-4" 
                    v-if="value?.photo?.profile"
                  >
                    <img :src="value.photo.profile" alt="Profile" />
                  </div>
                  <div 
                    v-else 
                    class="overlapping-avatar-placeholder elevation-4"
                    :style="{ border: `3px solid ${value?.baseInfo?.sectionColor?.backGround}` }"
                  >
                    <v-icon size="50" color="#ccc">mdi-account</v-icon>
                  </div>

                  <div class="profile-info w-100 mt-3 p-info-bg">
                    <h2 class="font-weight-black text-h5 mb-1 text-truncate" :style="{ color: value?.baseInfo?.sectionColor?.text || '#111' }">
                      {{ value?.organizationName || value?.visitName || 'مخاطب جدید' }}
                      <v-icon v-if="value?.isVerified" color="warning" size="20" class="ml-1">mdi-check-decagram</v-icon>
                    </h2>
                    <!-- <p v-if="value?.subtitle" class="font-weight-medium text-subtitle-2 mb-4" :style="{ color: value?.baseInfo?.sectionColor?.text || '#666' }">
                      {{ value.subtitle }}
                    </p> -->
                  </div>
                  <div class="d-flex flex-row w-100">

                  <!-- دکمه برجسته ذخیره مخاطب -->
                  <!-- <v-btn
                    @click="getVcf"
                    :loading="vcfLoading"
                    rounded
                    height="54"
                    class="save-contact-btn font-weight-bold text-subtitle-1 elevation-4 mt-2 mb-6"
                    :style="{
                      marginRight:'0px',
                      width: (value?.customerClub && (value.customerClub.configs?.isActive || value.customerClub.title?.trim() || value.customerClub.description?.trim())) ? '85% !important' : '100% !important',
                      border: `3px solid ${value?.baseInfo?.sectionColor?.backGround}`,
                      background: `${value?.baseInfo?.sectionColor?.backGround || '#111111'} !important`,
                      color: `${value?.baseInfo?.sectionColor?.text || '#ffffff'} !important`
                    }"
                  >
                    <v-icon right class="ml-2">mdi-account-plus</v-icon>
                    ذخیره در مخاطبین
                  </v-btn> -->
                  <v-tooltip 
            v-if="value?.customerClub && (value.customerClub.configs?.isActive || value.customerClub.title?.trim() || value.customerClub.description?.trim())"
              :value="
                value.advanceSettings &&
                value.advanceSettings.viewConfigs.showCClubOnload
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  fab
                  small
                  v-bind="attrs"
                  v-on="on"
                  width="54"
                  height="54"
                  @click="show"
                  class="save-contact-btn font-weight-bold text-subtitle-1 elevation-4 mt-2 mb-6 mx-2"
                    :style="{
                      border: `3px solid ${value?.baseInfo?.sectionColor?.backGround}`,
                      background: `${value?.baseInfo?.sectionColor?.backGround || '#111111'} !important`,
                      color: `${value?.baseInfo?.sectionColor?.text || '#ffffff'} !important`
                    }"
                >
                  <v-icon>mdi-card-account-phone-outline</v-icon>
                </v-btn>
              </template>
              <span>{{
                value?.advanceSettings &&
                value?.advanceSettings?.viewConfigs?.showCClubOnload
                  ? "نمایش خودکار"
                  : "باشگاه مشتریان"
              }}</span>
                  </v-tooltip>
                  </div>
                </div>
              </template>
               <!-- ۳. درباره ما (همراه با بوردر همرنگ دکمه) -->
              <template v-if="(item.name || item) === 'about' && ((value?.aboutUs && value?.designSettings?.layout!=='SocialExpandable') || value?.website?.trim()!=='')">
                <div 
                  class="about-glass-card content-card mx-4 mb-5 pa-5"
                  :style="{ border: `2px solid ${value?.baseInfo?.sectionColor?.backGround || '#eee'}` }"
                >
                  <h3 v-if="(value?.aboutUs && value?.designSettings?.layout!=='SocialExpandable')"
                      class="text-subtitle-1 font-weight-bold mb-2 text-center" :style="{ color: value?.baseInfo?.sectionColor?.text || '#333' }">درباره من</h3>
                  <div v-if="(value?.aboutUs && value?.designSettings?.layout!=='SocialExpandable')"
                      class="divider-line mb-3" :style="{ background: value?.baseInfo?.sectionColor?.backGround || '#e0e0e0' }"></div>
                  <p v-if="(value?.aboutUs && value?.designSettings?.layout!=='SocialExpandable')"
                      class="text-center mb-0 text-body-2" style="line-height: 1.8;" :style="{ color: value?.baseInfo?.sectionColor?.text || '#555' }">
                    {{ value.aboutUs }}
                  </p>
                  <a 
                      v-if="value?.website" 
                      :href="value.website.startsWith('http') ? value.website : 'https://' + value.website" 
                      target="_blank" 
                      class="text-decoration-none mt-3 d-flex align-center justify-center font-weight-medium px-4 py-2 rounded-pill"
                      :style="{ 
                        color: value?.baseInfo?.sectionColor?.text || '#1976d2',
                        background: 'rgba(255, 255, 255, 0.5)',
                        maxWidth: '100%'
                      }"
                    >
                      
                      <span 
                        class="d-inline-block text-truncate" 
                        style="max-width: 170px; direction: ltr; text-align: left;"
                      >
                        {{ value.website.replace(/^https?:\/\//, '') }}
                      </span>
                     <v-icon small class="mr-2" :color="value?.baseInfo?.sectionColor?.text || '#1976d2'">mdi-web</v-icon>

                    </a>
                </div>
              </template>
              <!-- ۱. بنر -->
              <template v-if="(item.name || item) === 'banner'">
                <div class="header-banner-wrapper banner-glass-container elevation-4 rounded-xl overflow-hidden mb-2">
                  <div v-if="computedBanner" class="banner-inner">
                    <b-intro-slider-view
                      v-model="computedBanner"
                      :is-slider="false"
                      type="banner"
                      class="banner-component"
                    />
                  </div>
                  <!-- یک پس‌زمینه رنگی پیش‌فرض در صورت نبود بنر تصویری (اگر بک‌گراند عکس نداشت) -->
                  <div v-else-if="!backgroundImage" class="banner-inner fallback-banner" :style="{ background: value?.baseInfo?.sectionColor?.backGround || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }"></div>
                </div>
              </template>

             
             
              <!-- ۴. شبکه‌های اجتماعی (همراه با بوردر همرنگ دکمه) -->
              <template v-if="(item.name || item) === 'socialMedia'">
                <div 
                  class="social-glass-container social-section mx-4 mb-6 pa-4 content-card"
                  :style="{ border: `2px solid ${value?.baseInfo?.sectionColor?.backGround || '#eee'}` }"
                >
                  <h3 v-if="value?.designSettings?.layout!=='SocialExpandable'" class="text-subtitle-1 font-weight-bold mb-4 text-center" :style="{ color: value?.baseInfo?.sectionColor?.text || '#333' }">{{ value?.buttonName || '' }}</h3>
                  <view-social v-model="value" layoutMode="grid2" :showHeader="false" style="width: 100%;" />
                </div>
              </template>

            </div>
          </template>
        </drag-list>
        
        <!-- فوتر -->
        <div class="d-flex align-center justify-center opacity-70 mt-4 mb-8 pb-4" @click="openLink">
          <img src="media/cr_logo.webp" alt="Terminal Ads Logo" height="14" style="filter: grayscale(3%); opacity: 0.7;" />
          <span class="text-caption font-weight-medium mr-2" :style="{ color: value?.baseInfo?.sectionColor?.text || '#888' }">قدرت گرفته از کیوآر لند</span>
        </div>
        
      </div>
    </div>
  </mock-up-main>
</template>

<script>
import DragList from "@/view/pages/qrland/dragList"; 
import BIntroSliderView from "../../../../pages/businessPage/components/view/bIntroSliderView.vue";
import ViewSocial from "@/view/pages/otherQrTypes/socialMedia/component/viewSocial";
import FloatingBtn from "./floatingBtn.vue";
import MockUpMain from "../../../businessPage/components/mockUp";
import { AtomSpinner } from "epic-spinners"; 
import { Bus } from "@/main";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib/components";

export default {
  name: "socialMobile3_ok",
  components: {
    MockUpMain,
    DragList,
    ViewSocial,
    BIntroSliderView,
    FloatingBtn,
    AtomSpinner,
    VFadeTransition,
    VScaleTransition,
    VSlideXTransition,
    VSlideYTransition,
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
     orders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showconncet: false,
      showWelcome: false,
      vcfLoading: false,
      components: {
        scale: VScaleTransition,
        slideX: VSlideXTransition,
        slideY: VSlideYTransition,
        fade: VFadeTransition,
      },
    };
  },
  computed: {
          draggingKeys: {
      get() {
        return this.orders && this.orders.length > 0 
          ? this.orders 
          : [
              { name: 'banner' },
              { name: 'profile' },
              { name: 'about' },
              { name: 'socialMedia' }
            ];
      },
      set(val) {
        this.$emit('update:orders', val);        
      }
    },

    backgroundImage() {
      return this.value?.photo?.headBackground || null;      
    },
    computedBanner: {
      get() {
        if (this.value?.banner?.gallery?.[0]?.images?.length > 0) {
          return {
            banner: this.value.banner.gallery[0]
          };
        }
        return null;
      }
    }  
  },
  mounted() {
    Bus.$on("showMe", () => {
      if (this.value?.photo?.hasWelcome) {
        this.showWelcome = true;
        setTimeout(() => {
          this.showWelcome = false;
        }, 3000);
      }
    });
    
    // Fallback in case event is missed
    if (this.value?.photo?.hasWelcome) {
        this.showWelcome = true;
        setTimeout(() => {
          this.showWelcome = false;
        }, 3000);
    }
  },
  methods: {
        show() {
      this.showconncet = !this.showconncet;
      Bus.$emit("showconnect", this.showconncet);
    },
    getVcf() {
      if (!this.value) return;
      this.vcfLoading = true;
      const rawData = this.value.data ? this.value.data : this.value;

      try {
        const escapeVCardValue = (value = "") => {
          return String(value)
            .replace(/\\/g, "\\\\")
            .replace(/\n/g, "\\n")
            .replace(/\r/g, "")
            .replace(/,/g, "\\,")
            .replace(/;/g, "\\;");
        };

        const foldLine = (line, maxLength = 75) => {
          if (line.length <= maxLength) {
            return line;
          }
          let result = "";
          while (line.length > maxLength) {
            result += line.slice(0, maxLength) + "\r\n ";
            line = line.slice(maxLength);
          }
          result += line;
          return result;
        };

        const addLine = (arr, line) => {
          arr.push(foldLine(line));
        };

        const socialPlatforms = {
          instagram: { label: "Instagram", url: "https://instagram.com/" },
          telegram: { label: "Telegram", url: "https://t.me/" },
          whatsapp: { label: "WhatsApp", url: "https://wa.me/" },
          linkedin: { label: "LinkedIn", url: "https://linkedin.com/in/" },
          twitter: { label: "Twitter", url: "https://twitter.com/" },
          x: { label: "X", url: "https://x.com/" },
          facebook: { label: "Facebook", url: "https://facebook.com/" },
          youtube: { label: "YouTube", url: "https://youtube.com/@" },
          github: { label: "GitHub", url: "https://github.com/" },
          tiktok: { label: "TikTok", url: "https://tiktok.com/@" },
          pinterest: { label: "Pinterest", url: "https://pinterest.com/" },
          twitch: { label: "Twitch", url: "https://twitch.tv/" },
          aparat: { label: "Aparat", url: "https://aparat.com/" },
          eitaa: { label: "Eitaa", url: "https://eitaa.com/" },
          bale: { label: "Bale", url: "https://ble.ir/" },
          rubika: { label: "Rubika", url: "https://rubika.ir/" },
          soroush: { label: "Soroush+", url: "https://splus.ir/" },
          gap: { label: "Gap", url: "https://gap.im/" },
          igap: { label: "iGap", url: "https://igap.net/" },
          virgool: { label: "Virgool", url: "https://virgool.io/@" }
        };

        const normalizeSocialLink = (platform, value) => {
          value = String(value).trim();
          if (value.startsWith("http://") || value.startsWith("https://")) {
            return value;
          }
          if (value.startsWith("skype:")) {
            return value;
          }
          if (platform === "whatsapp") {
            const phone = value.replace(/[^\d]/g, "");
            return `https://wa.me/${phone}`;
          }
          const config = socialPlatforms[platform];
          if (config) {
            return config.url + value.replace(/^@/, "");
          }
          return `https://${value}`;
        };

        let vcard = [];
        addLine(vcard, "BEGIN:VCARD");
        addLine(vcard, "VERSION:3.0");
        addLine(vcard, "PRODID:-//Digital Card//FA//EN");

        const name = rawData?.organizationName || rawData?.visitName || "مخاطب جدید";
        addLine(vcard, `N;CHARSET=UTF-8:;${escapeVCardValue(name)};;;`);
        addLine(vcard, `FN;CHARSET=UTF-8:${escapeVCardValue(name)}`);

        if (rawData?.organizationName) {
          addLine(vcard, `ORG;CHARSET=UTF-8:${escapeVCardValue(rawData.organizationName)}`);
        }
        if (rawData?.website) {
          addLine(vcard, `URL:${escapeVCardValue(rawData.website)}`);
        }

        let notesArray = [];
        if (rawData?.aboutUs) {
          notesArray.push(rawData.aboutUs);
        }

        let itemIndex = 1;
        if (rawData?.socialMedia) {
          const sm = rawData.socialMedia;
          for (const [platform, items] of Object.entries(sm)) {
            if (!Array.isArray(items)) continue;
            for (const item of items) {
              if (!item?.url) continue;
              const lowerPlatform = platform.toLowerCase();
              let value = String(item.url).trim();

              if (["phone", "mobile", "call"].includes(lowerPlatform)) {
                const cleanPhone = value.replace(/[^\d+]/g, "");
                addLine(vcard, `TEL;TYPE=CELL,VOICE:${cleanPhone}`);
                continue;
              }

              if (lowerPlatform === "whatsapp") {
                const cleanPhone = value.replace(/[^\d]/g, "");
                addLine(vcard, `TEL;TYPE=CELL:${cleanPhone}`);
                const waLink = `https://wa.me/${cleanPhone}`;
                notesArray.push(`WhatsApp: ${waLink}`);
                continue;
              }

              if (lowerPlatform === "email") {
                addLine(vcard, `EMAIL;TYPE=INTERNET:${escapeVCardValue(value)}`);
                continue;
              }

              if (lowerPlatform === "address") {
                addLine(vcard, `ADR;TYPE=WORK;CHARSET=UTF-8:;;${escapeVCardValue(value)};;;;`);
                continue;
              }

              const link = normalizeSocialLink(lowerPlatform, value);
              const label = socialPlatforms[lowerPlatform]?.label || platform;

              addLine(vcard, `item${itemIndex}.URL:${escapeVCardValue(link)}`);
              addLine(vcard, `item${itemIndex}.X-ABLabel:${escapeVCardValue(label)}`);
              addLine(vcard, `X-SOCIALPROFILE;TYPE=${lowerPlatform}:${escapeVCardValue(link)}`);
              
              notesArray.push(`${label}: ${link}`);
              itemIndex++;
            }
          }
        }

        if (notesArray.length) {
          addLine(vcard, `NOTE;CHARSET=UTF-8:${escapeVCardValue(notesArray.join("\n"))}`);
        }

        addLine(vcard, "END:VCARD");
        const vcardString = vcard.join("\r\n");
        const blob = new Blob([vcardString], { type: "text/vcard;charset=utf-8;" });
        const fileName = `${name.replace(/\s+/g, "_")}.vcf`;

        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const dLink = document.createElement("a");
          const url = URL.createObjectURL(blob);
          dLink.href = url;
          dLink.download = fileName;
          dLink.style.display = "none";
          document.body.appendChild(dLink);
          dLink.click();
          document.body.removeChild(dLink);
          setTimeout(() => { URL.revokeObjectURL(url); }, 1000);
        }
      } catch (error) {
        console.error("خطا در ساخت فایل VCF:", error);
      } finally {
        this.vcfLoading = false;
      }
    }
  }
};
</script>

<style scoped>
* {
  font-family: 'Vazirmatn', 'Vazir', Tahoma, sans-serif !important;
}

/* پنهان کردن اسکرول بار اما حفظ قابلیت اسکرول */
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* دکمه شناور ظریف */
.modern-float-btn {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* استایل بنر هدر */
.header-banner-wrapper {
  margin: 18px;
  width: calc(100%-18px);
  max-width: calc(100%-18px);
  height: 220px;
  position: relative;
  padding: 9px;
  display: flex;
  border-radius: 15px 15px 0 0;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.banner-inner {
  width: calc(100%-9px);
  max-width: calc(100%-9px);
  height: 100%;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
}
.banner-component {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bg-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(255, 255, 255, 0.4); 
  backdrop-filter: blur(15px);
  z-index: 1;
}

/* آواتار متقاطع - بالاتر کشیده شد (margin-top بیشتر شد) */
.profile-section {
  position: relative;
  margin-top: -85px; /* لوگو مقداری بالاتر رفت */
  z-index: 2;
}

.overlapping-avatar {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  /* بوردر از طریق استایل خطی داینامیک می‌آید */
  border-width: 4px;
  border-style: solid;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.overlapping-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlapping-avatar-placeholder {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  border-width: 4px;
  border-style: solid;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* نام و مشخصات پروفایل */
.p-info-bg {
  border-radius: 12px;
  padding: 5px;
}

/* دکمه برجسته ذخیره مخاطب */
.save-contact-btn {
  max-width: 300px;
  margin: 0 auto;
  letter-spacing: 0.5px;
  transition: transform 0.2s;
}
.save-contact-btn:active {
  transform: scale(0.97);
}

/* کارت‌های محتوایی (درباره ما، لینک‌ها) با بک‌گراند نیمه‌شفاف برای خوانایی روی عکس */
.content-card {
  background: rgba(255, 255, 255, 0.85); /* پس‌زمینه سفید کمی شیشه‌ای برای خوانایی روی تصویر پس‌زمینه */
  backdrop-filter: blur(5px);
  border-radius: 24px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);
}

.divider-line {
  width: 40px;
  height: 3px;
  margin: 0 auto;
  border-radius: 2px;
}

::v-deep .drag-item-wrapper {
  box-sizing: border-box !important;
}
.profile-glass-card, .about-glass-card, .social-glass-container {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.41) !important;
}
.banner-glass-container {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.5);
}
::v-deep .social-glass-container a, 
::v-deep .social-glass-container span,
::v-deep .social-glass-container p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
  direction: ltr;
  display: inline-block;
}

</style>
